import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

import User from '@core/models/user/User';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { getAccountConfig } from '@accountFederation/config/accountConfig';

export const KycFlowStates = {
    NewVerification: 'NewVerification',
    GetIdVerification: 'GetIdVerification',
    OldVerification: 'OldVerification',
    Intro: 'Intro',
    GetIdIntro: 'GetIdIntro',
    Pending: 'Pending',
} as const;

export type KycFlowStates = typeof KycFlowStates[keyof typeof KycFlowStates];

export function getInitialKycFlowState(
    isMultiStepIdVerificationEnabled: boolean,
    user: User,
    isKycPending: boolean,
    isDefaultIntroChanged: boolean,
    hasGetIdKyc: boolean,
) {
    if (hasGetIdKyc) {
        return KycFlowStates.GetIdIntro;
    }

    return isMultiStepIdVerificationEnabled
        ? newKycFlow(user, isKycPending, isDefaultIntroChanged)
        : oldKycFlow(isKycPending);
}

function newKycFlow(user: User, isKycPending: boolean, isDefaultIntroChanged: boolean) {
    if ((!isKycPending && !user.isVerifiedIdCard)
    || (user.isVerifiedIdCard && !isKycPending && !isDefaultIntroChanged)) {
        return KycFlowStates.Intro;
    }

    return user.isVerifiedIdCard
        ? KycFlowStates.NewVerification
        : KycFlowStates.Pending;
}

// for old kyc we will not have pending modal because there this is happening in template
function oldKycFlow(isKycPending: boolean) {
    return isKycPending ? KycFlowStates.OldVerification : KycFlowStates.Intro;
}

export function getIntermediaryStep() {
    if (getAccountConfig().hasGetIdKyc) {
        return modalCodes.getIdVerification;
    }

    if (!getConfig().countrySpecific.user.idCardVerification.isCompleteRegistrationNeededForKyc) {
        return false;
    }
    if (getConfig().countrySpecific.country === Country.Rs) {
        return modalCodes.multiStepIdVerificationCollectData;
    }

    return modalCodes.completeRegistration;
}
